import React from 'react';
import './ProjectModal.css';

const ProjectModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h3>Project In Development</h3>
        <p>This project is currently in progress. Check back soon for updates!</p>
        <button className="modal-close" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default ProjectModal; 